/* eslint-disable import/no-cycle */
import React from "react";

import moment from "moment";

import { Dialog } from "primereact";
import ReactPaginate from "react-paginate";
import { Spinner } from "react-bootstrap";

import { useHistory } from "react-router-dom";
import BackButtom from "../../../../components/backButton";
import DataGrid, { ItemField } from "../../../../components/datagrid";
import ChooseModal from "../../../../components/modals/choose-modal";
import Icons from "../../../../components/icons-helper";
import ButtonRound from "../../../../components/button-action";
import ResumeFiscalNote from "../../../../components/resume";
import { DocumentCard } from "../../../../components/cards";

import { FilterModel } from "../../../../../domain/models/enum";

import { Cards, CardWrapper, IframeStyled, Wrapper } from "./styles";
import { theme } from "../../../../styles/theme";
import { ContainerButtonActions } from "../../issue/form/styles";
import { PaginateStyled } from "../../../../components/datagrid/styled";

import { documentType, parseDateWithoutTimezone } from "../../../../../utils";
import {
  displayCancelMessage,
  cancelRecurrenceFiscalNote,
} from "./utils";
import {
  showErrorMessage,
  handleClickInfo,
} from "../../../../helpers";
import { settings } from "../../../../../main/configs/settings";
import { FiscalNoteModel, FiscalNoteResponseModel } from "../../../../../domain/models/fiscal-note";
import { Filters } from "./filters";
import { Link } from "../../../../components/cards/navigate-card/styles";
import Icon from "../../../../components/icon";
import { statusEnumList } from "../../../../../utils/status-enum";

type PageProps = {
  list: FiscalNoteResponseModel | undefined;
  setParams: any;
  loading?: boolean;
  handleReload: () => void;
  isSuperAdmin?: boolean;
};

export const formCurrency = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
  minimumFractionDigits: 2,
});

export const formCurrencyByCountry = (
  localeCountry: string,
  currencyCountry: string,
): Intl.NumberFormat => {
  const formatedNumber = new Intl.NumberFormat(localeCountry, {
    style: "currency",
    currency: currencyCountry,
    minimumFractionDigits: 2,
  });
  return formatedNumber;
};

const DocumentsListPage: React.FC<PageProps> = ({
  list,
  setParams,
  loading,
  handleReload,
  isSuperAdmin,
}) => {
  const [selectedDocument, setSelectedDocument] = React.useState<
    FiscalNoteModel | undefined
  >();
  const [removeRecurrence, setRemoveRecurrence] = React.useState<FiscalNoteModel | undefined>();
  const [view, setView] = React.useState<any | undefined>();

  const [shouldForcePage, setShouldForcePage] = React.useState<boolean>(false);
  const history = useHistory();


  const handleClickView = async (data: FiscalNoteModel): Promise<void> => {
    // modaol to edit
    setSelectedDocument(data);
  };


  const fields: ItemField[] = [
    {
      title: "Criado em",
      key: "issuedOn",
      size: 130,
      renderItem: (data: FiscalNoteModel) =>
        moment(data?.emissionDate).format("DD/MM/YYYY"),
    },
    {
      title: "Data da primeira nota",
      key: "dayOfRecurrence",
      renderItem: (data: FiscalNoteModel) => {
        if (!data.dayOfRecurrence) {
          return "-";
        }
        const date = parseDateWithoutTimezone(data.dayOfRecurrence);
        const day = date.toLocaleDateString();

        return day;
      },
    },
    {
      title: "Dia da recorrência",
      key: "dayOfRecurrence",
      size: 80,
      renderItem: (data: FiscalNoteModel) => {
        if (!data.dayOfRecurrence) {
          return "-";
        }
        const date = parseDateWithoutTimezone(data.dayOfRecurrence);
        const day = date.getDate().toString().padStart(2, "0");

        return day;
      },
    },
    {
      title: "Padrão",
      key: "hasNationalFiscal",
      size: 100,
      renderItem: (data: FiscalNoteModel) =>
        data?.hasNationalFiscal ? "Nacional" : "Municipal",
    },
    ...(isSuperAdmin
      ? [
        {
          title: "Prestador",
          key: "prestador",
          renderItem: (data: FiscalNoteModel) => {
            const name = data?.developerCompany?.company?.socialReason || "-";
            return <span title={name} style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 180 }}>{name}</span>;
          },
        },
      ]
      : []),
    {
      title: "Tomador",
      key: "tomador",
      renderItem: (data: FiscalNoteModel) => {
        const name = data?.taker?.socialReason || "-";
        return <span title={name} style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 180 }}>{name}</span>;
      },
    },
    {
      title: "Valor",
      key: "name",
      renderItem: (data: FiscalNoteModel) =>
        formCurrency.format(
          Number(data?.noteValue),
        ),
    },
    {
      title: "Ações",
      key: "actions",
      renderItem: (data: FiscalNoteModel) => (
        <ContainerButtonActions>
          {data?.hasRecurrence && <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            title="Editar"
            onClick={() => history.push(`/recurrency/${data?.id}`)}
            color={theme.colors.green}
          >
            <Icons
              height={25}
              width={25}
              name="edit"
              color={theme.colors.green}
            />
          </ButtonRound>}
          <ButtonRound
            backgroundColor={theme.colors.darkBlue}
            title="Derivadas"
            onClick={() => history.push(`/recurrency/${data?.id}/notes`)}
            color={theme.colors.blue400}
          >
            <Icons
              height={25}
              width={25}
              name="nf"
              color={theme.colors.blue400}
            />
          </ButtonRound>
          {data?.hasRecurrence && <ButtonRound
            hasRecurrence="true"
            backgroundColor={theme.colors.darkBlue}
            onClick={() => {
              setRemoveRecurrence(data);
            }}
            title="Cancelar Recorrência"
            color={theme.colors.red}
            minWidth="200px"
          >
            <Icons
              height={15}
              width={15}
              name="close"
              color={theme.colors.red}
            />
          </ButtonRound>}
        </ContainerButtonActions>
      ),
    },
  ];

  const handlePage = (e: any): void => {
    setParams((prev: FilterModel) => ({
      ...prev,
      page: e,
    }));

    setShouldForcePage(false);
  };

  const handleError = (error: any): any => {
    showErrorMessage(
      error?.userMessage || error?.detail || "Erro desconhecido",
    );
  };

  const handleCancelRecurrenceNote = async (noteId: number): Promise<void> => {
    try {
      await cancelRecurrenceFiscalNote(noteId);
      handleReload();
      displayCancelMessage("RECURRENCE" as string);
    } catch (error) {
      handleError(error);
    } finally {
      setRemoveRecurrence(undefined);
    }
  };

  return (
    <Wrapper>
      <BackButtom text="Notas Recorrentes" />
      <CardWrapper>
        <Filters onSubmit={e => setParams(e)} />
        <Link to="/recurrency/create" invertColor={false} style={{ maxWidth: 280 }}>
          Nova Nota Recorrente <Icon name="arrow-right" />
        </Link>
      </CardWrapper>
      <Cards>
        {loading && (
          <div className="d-flex justify-content-center">
            <Spinner animation="grow" variant="primary" />
          </div>
        )}

        {!loading &&
          list?.content.map((item: any) => (
            <DocumentCard
              key={item.id}
              actions={{
                detail: () => handleClickInfo(item),
                view: () => handleClickView(item),
                download: () => console.log("download"),
                cancel: () => console.log("cancel"),
              }}
              docType={documentType.find((el) => el.ENUM === item.type)?.label}
              number={item?.fiscalNote?.nfseNumber || item?.invoice?.id}
              date={moment(item?.issuedOn).format("DD/MM/YYYY")}
              taker={
                item?.fiscalNote?.taker?.socialReason ||
                item?.invoice?.companyName
              }
              status={statusEnumList.find((el) => el.ENUM === item?.status)?.label}
              value={
                formCurrency.format(
                  Number(item?.fiscalNote?.noteValue || item?.invoice?.total),
                ) as any
              }
            />
          ))}

        <PaginateStyled>
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            pageRangeDisplayed={settings.perPage}
            previousLabel="<"
            nextClassName="next-button"
            prevClassName="prev-button"
            pageCount={list?.totalPages || 0}
            forcePage={shouldForcePage ? 0 : undefined}
            onPageChange={(e: any) => handlePage(e.selected)}
          />
        </PaginateStyled>
      </Cards>

      <DataGrid
        loading={!!loading}
        fields={fields}
        data={list?.content || []}
        totalPages={list?.totalPages || 0}
        changePage={handlePage}
        shouldForcePage={shouldForcePage}
      />
      <ChooseModal
        text="Você deseja realmente cancelar a recorrência?"
        onConfirm={() => removeRecurrence?.id && handleCancelRecurrenceNote(removeRecurrence?.id)}
        onCancel={() => setRemoveRecurrence(undefined)}
        isVisible={!!removeRecurrence}
        toggleVisibility={() => setRemoveRecurrence(undefined)}
      />
      <Dialog
        header="Resumo da Nota Fiscal:"
        visible={!!selectedDocument}
        style={{ width: window.innerWidth < 479 ? "90vw" : "50vw" }}
        footer={null}
        onHide={() => setSelectedDocument(undefined)}
      >
        <ResumeFiscalNote
          fiscalNote={{ ...selectedDocument, hasRecurrence: "true" }}
        />
      </Dialog>
      <Dialog
        visible={!!view}
        style={{
          width: window.innerWidth < 768 ? "90vw" : "50vw",
          background: theme.colors.darkBlue,
        }}
        headerStyle={{ background: theme.colors.darkBlue }}
        contentStyle={{ background: theme.colors.darkBlue }}
        footer={null}
        onHide={() => setView(undefined)}
      >
        <div>
          {view?.pdf && (
            <IframeStyled title="pdf" src={`${view?.pdf}#toolbar=0`} />
          )}
        </div>
      </Dialog>
    </Wrapper>
  );
};
export default DocumentsListPage;
